export default {
  success: "Operación exitosa"
  , error: "Ocurrió un error desconocido"
  , warning: "Hay una alerta"
  , validof: "Por favor, valide los campos obligatorios"
  , nochanges: "No hay cambios en el formulario"
  , network: {
    500: {
      type: "Server Error"
      , desc: "(500) El servicio no está disponible"
    }
    , 504: {
      type: "Server Error"
      , desc: "(504) El servicio no está disponible"
    }
    , 503: {
      type: "Servicio No Disponible"
      , desc: "Lo sentimos, el servicio no esta disponible por el momento"
      , instructions: "Aguarde un momento por favor, el sistema esta en modo de mantenimiento"
    }
    , 403: {
      type: "Server Error"
      , desc: "(403) El servicio no está disponible"
    }
    , 401: {
      type: "Unauthorized"
      , desc: "Lo sentimos, el acceso a la página fue denegado. No cuentas con los permisos para ver está página"
      , instructions: "Aguarde un momento por favor, serás redireccionado al inicio del sitio"
    }
    , 404: {
      type: "Page Not Found"
      , desc: "Lo sentimos, la página que buscas no ha sido encontrada"
      , instructions: "Aguarde un momento por favor, serás redireccionado al inicio del sitio"
    }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/errors/index.js